<template>
  <base-modal
    :title="componentName + ' is referenced in...'"
    @closeModal="onCloseModal"
  >
    <div class="wrapper clearfix">
      <div class="label">{{ components.length }} Components</div>
      <div
        v-if="components.length >= 1"
        style="display: flex; flex-wrap: wrap;"
      >
        <component-tag
          v-for="(item, index) in components"
          :key="index"
          :item="item"
          @clickComponentTag="onClickComponentTag(item)"
        />
      </div>
      <div v-else class="empty">
        {{ componentName }} is not referenced inside any components
      </div>
      <!-- Elements -->
      <div class="label">{{ elements.length }} Elements</div>
      <board-card
        v-for="(value, key, index) in boards"
        :id="key"
        :key="key"
        :value="value"
        :index="index"
      />
    </div>
    <!-- </div> -->
  </base-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import { has } from '../../../utils.js';
import BaseModal from '../BaseModal.vue';
import ComponentTag from '../BoardPropertiesModal/ComponentTag.vue';
import BoardCard from './BoardCard.vue';

export default {
  components: {
    BaseModal,
    ComponentTag,
    BoardCard,
  },

  computed: {
    ...mapGetters('application/modals', ['getComponentPropertiesModal']),
    ...mapGetters('project/data/boards', {
      getBoard: 'getNode',
      getAllBoards: 'getAllNodes',
      getContainedNodes: 'getContainedNodes',
    }),
    ...mapGetters('project/data/boards', [
      'getContainedNodes',
      'getRootContainer',
    ]),
    ...mapGetters('project/data/components', ['getNode']),
    ...mapGetters('project/data/components', {
      getAllComponentNodes: 'getAllNodes',
    }),
    ...mapGetters('project/data/elements', {
      getElement: 'getNode',
      getAllElementNodes: 'getAllNodes',
    }),
    ...mapGetters('project/data/attributes', {
      getAttribute: 'getNode',
    }),

    /**
     * Return the component id for which to show the component properties
     * @return {String}     The component id
     */
    componentId() {
      return this.getComponentPropertiesModal;
    },

    /**
     * Return the name of the component
     * @returns {String}
     */
    componentName() {
      return this.getNode(this.componentId).name;
    },
    /**
     * Return all boards which contain elements which contain this component ref in the project
     * @returns {Array}    The boards
     */
    boards() {
      const boardRefs = {};

      // Remove all board folders from array
      const boards = this.getAllBoards.filter(item => !item.children);
      console.log('boards: ', boards);

      // Get each boards elements
      Object.keys(boards).forEach(key => {
        const boardId = boards[key].id;

        console.log('boardId: ', boardId);
        const elements = this.getContainedNodes(
          boardId,
          'elements',
          'elements'
        );
        console.log('elements: ', elements);
        // Cycle in each element for component references
        Object.keys(elements).forEach(elem => {
          const { components } = elements[elem];
          // if an element has a components list
          if (components.length > 0) {
            // Loop inside the component list
            Object.keys(components).forEach(comp => {
              const compId = components[comp].component;

              // if a component inside the list matches the opened component properties
              if (compId === this.componentId) {
                // Store the board id in an array if it is not already there
                if (!has(boardRefs, boardId)) {
                  boardRefs[boardId] = [];
                }
                // Store the elementid that contains this component in the board
                console.log('boardId: ', boardRefs[boardId]);
                console.log('elementID: ', elements[elem].id);
                boardRefs[boardId].push(elements[elem].id);
              }
            });
          }
        });
      });
      console.log('boardRefs: ', boardRefs);
      return boardRefs;
    },

    /**
     * Return all the component references inside elements in the project
     * @returns {Array}    The components
     */
    elements() {
      const elemRefs = [];

      // Get all elements
      const allElems = this.getAllElementNodes;
      console.log('allElems: ', allElems);

      // Get each elements attached components
      Object.keys(allElems).forEach(key => {
        const { components } = allElems[key];
        // if an element has a components list
        if (components.length > 0) {
          // Loop inside the component list
          Object.keys(components).forEach(comp => {
            const compId = components[comp].component;

            // if a component inside the list matches the opened component properties
            if (compId === this.componentId) {
              // Store the elementid that contains this component in one of its list
              elemRefs.push(this.getElement(allElems[key].id));
            }
          });
          console.log('components: ', components);
        }
      });
      console.log('elemRefs: ', elemRefs);

      // Remove duplicates
      const flatRefs = _.uniqBy(elemRefs.flat());

      return flatRefs;
    },

    /**
     * Return all the component references inside other components in the project
     * @returns {Array}    The components
     */
    components() {
      const compRefs = [];

      // Remove all component folders from array
      const arr = this.getAllComponentNodes.filter(item => !item.children);

      // Get each components attributes
      Object.keys(arr).forEach(key => {
        const { attributes } = arr[key];

        // Loop inside each components attributes
        Object.keys(attributes).forEach(value => {
          const attribute = this.getAttribute(attributes[value]);
          // if it is a component-list
          if (attribute.value.type === 'component-list') {
            // Loop inside the component list
            Object.keys(attribute.value.data).forEach(comp => {
              const compId = attribute.value.data[comp].component;

              // if a component inside the list matches the opened component properties
              if (compId === this.componentId) {
                // Store the parent component that contains this component in one of its list
                compRefs.push(this.getNode(arr[key].id));
              }
            });
          }
        });
      });

      // Remove duplicates
      const flatRefs = _.uniqBy(compRefs.flat());

      return flatRefs;
    },
  },

  methods: {
    ...mapActions('application/modals', ['setComponentPropertiesModal']),
    ...mapActions('project/config/components', ['setOpen']),

    /**
     * Event listener for pressing the close button
     */
    onCloseModal() {
      this.setComponentPropertiesModal({ value: null });
    },
    /**
     * Event listener for clicking on a component tag
     */
    onClickComponentTag(item) {
      // console.log('item: ', item);
      this.setOpen({ id: item.id, apply: true });
      this.setComponentPropertiesModal({ value: null });
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  padding: 0 20px 20px;
  .label {
    color: #828585;
    font-size: 15px;
    padding: 20px 0;
  }
  .empty {
    // background: #ccc;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    border: 1px solid #41494b;
  }
  &.clearfix::after {
    content: '';
    clear: both;
    display: table;
  }
  .tag {
    &:hover {
      cursor: pointer;
    }
  }
}

// .tbl {
//   border-spacing: 0;
//   border-collapse: collapse;
//   width: 100%;
//   margin: 15px 0 10px 0;
//   font-size: 15px;
//   table-layout: fixed;

//   tr {
//     vertical-align: top;

//     td {
//       padding: 0;
//       height: 50px;
//       text-align: left;
//       vertical-align: middle;
//       box-sizing: border-box;
//       &.right span {
//         color: #fff;
//         font-weight: 600;
//       }
//       &.left {
//         color: #828585;
//         width: 100px;
//       }
//     }
//   }
// }
</style>
